import { getHttpClient, errorDesconocido } from "../../../../core/utils/httpClient";
import basicList from "../../../../core/redux/actions/list";

const PREFIX = "MANAGER_PURCHASE_ORDER_LIST";
const getState = (state) => state.manager.purchaseOrder.list;

const {
    /**
     * Main request & reset
     */
    getListPattern,
    listReset: reset,

    /**
     * Element's actions
     */
    actionDeletePattern,
    actionPutPattern,

    /**
     * Selectores
     */
    getMeta,
    getList,
    getError,
    isLoaded,
    isLoading,
    isSecondaryLoading,

    generalDownload,
} = basicList(PREFIX, getState);

const list = (queryParams) => {
    /**
     * Add hidden parameters to make the API call
     */
    const hiddenParams = { vendor: 1 };

    /**
     * It's also possible to remove and sanitize some parameters
     */
    const customQueryParams = { ...queryParams, ...hiddenParams };

    /**
     * Call to the API
     */
    return getListPattern("manager/purchase-orders/v1/", customQueryParams);
};

export { list, reset, getMeta, getList, getError, isLoaded, isLoading, isSecondaryLoading };

export const remove = (id) =>
    actionDeletePattern(
        "manager/purchase-orders/v1/" + id,
        {},
        {
            message: "Deleted",
            description: "The purchase order was deleted",
        }
    );

export const downloadFile = (id, name) => generalDownload(`manager/purchase-orders/v1/${id}/download.xlsx`, name);
